export default "__VITE_ASSET__BZO6ytzn__"